<template>
  <div id="app" class="mapping-wrapper">

    <!-- Loading & Snackbar -->
    <loadingcomp :mesaj="' '" v-model="loadingvmodel" />
    <snackbarcomp :mesaj="text1" v-model="snackbar" />

    <v-card flat class="mapping-card">

      <!-- ================== TABS ================== -->
      <v-tabs v-model="activeTab" color="info" dark slider-color="yellow">
        <v-tab>Eşleştir</v-tab>
        <v-tab>Eşleştirilen Oteller</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">

        <!-- ================================================= -->
        <!-- ================= TAB 0 : EŞLEŞTİR ============== -->
        <!-- ================================================= -->
        <v-tab-item>
          <v-layout row wrap>

            <v-flex xs12>
              <v-toolbar flat dark color="info" class="mapping-toolbar">
                <v-toolbar-title class="mapping-title">
                  Otel Mapping (Otel Eşleştir)
                </v-toolbar-title>
              </v-toolbar>
            </v-flex>

            <v-flex xs12>
              <v-container fluid class="mt-4">
                <v-card flat class="inner-card">
                  <v-card-title>
                    <span class="title font-weight-bold">
                      Arkman Mapping Otel
                    </span>
                  </v-card-title>

                  <v-card-text>
                    <v-layout row wrap>

                      <!-- ========= RATEHAWK ========= -->
                      <v-flex xs12 sm6 class="column-card">
                        <v-card flat>

                          <v-subheader class="column-header">
                            Arkman Mapping Otel Arama
                          </v-subheader>

                          <v-layout row wrap align-center class="search-row">
                            <v-flex xs9>
                              <v-text-field
                                label="Arkman Mapping Otel Adı"
                                v-model="arkmanMapping.ratehawk.searchText"
                                hide-details
                              />
                            </v-flex>

                            <v-flex xs3>
                              <v-btn
                                block
                                color="info"
                                :loading="arkmanMapping.ratehawk.loading"
                                @click="searchRatehawk"
                              >
                                <v-icon left>search</v-icon>
                                Ara
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <div
                            v-if="arkmanMapping.ratehawk.selected"
                            class="selected-summary"
                          >
                            Seçilen Otel:
                            <strong>
                              {{ arkmanMapping.ratehawk.selected.Name }}
                            </strong>
                          </div>

                          <v-slide-y-transition>
                            <div
                              v-if="showRatehawkList && ratehawkPaged.length"
                              class="list-wrapper"
                            >
                              <v-list dense>
                                <v-list-tile
                                  v-for="h in ratehawkPaged"
                                  :key="h.Id"
                                  @click="selectRatehawkHotel(h)"
                                  :class="[
                                    'hotel-item',
                                    {
                                      'hotel-item--selected':
                                        arkmanMapping.ratehawk.selected &&
                                        arkmanMapping.ratehawk.selected.Id === h.Id
                                    }
                                  ]"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ h.Name }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>

                              <!-- Pagination -->
                              <v-layout
                                row
                                justify-space-between
                                align-center
                                class="pagination-row"
                              >
                                <v-btn
                                  small
                                  flat
                                  @click="prevRatehawkPage"
                                  :disabled="ratehawkPage === 1"
                                >
                                  <v-icon left small>chevron_left</v-icon>
                                  Geri
                                </v-btn>

                                <span class="page-info">
                                  {{ ratehawkPage }} / {{ ratehawkMaxPage }}
                                </span>

                                <v-btn
                                  small
                                  flat
                                  @click="nextRatehawkPage"
                                  :disabled="
                                    arkmanMapping.ratehawk.loading ||
                                    (!arkmanMapping.ratehawk.hasMoreBackendData &&
                                     ratehawkPage >= ratehawkMaxPage)
                                  "
                                >
                                  İleri
                                  <v-icon right small>chevron_right</v-icon>
                                </v-btn>
                              </v-layout>

                              <div
                                v-if="
                                  !arkmanMapping.ratehawk.hasMoreBackendData &&
                                  ratehawkPage === ratehawkMaxPage
                                "
                                class="text-xs-center pa-2 grey--text"
                              >
                                — Son kayıt —
                              </div>

                            </div>
                          </v-slide-y-transition>

                        </v-card>
                      </v-flex>

                      <!-- ========= COPER ========= -->
                      <v-flex xs12 sm6 class="column-card">
                        <v-card flat>

                          <v-subheader class="column-header">
                            Coper Otel Arama
                          </v-subheader>

                          <v-layout row wrap align-center class="search-row">
                            <v-flex xs9>
                              <v-text-field
                                label="Coper Otel Adı"
                                v-model="arkmanMapping.coper.searchText"
                                hide-details
                              />
                            </v-flex>

                            <v-flex xs3>
                              <v-btn
                                block
                                color="info"
                                :loading="arkmanMapping.coper.loading"
                                @click="searchCoperHotels"
                              >
                                <v-icon left>search</v-icon>
                                Ara
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <div
                            v-if="arkmanMapping.coper.selected"
                            class="selected-summary"
                          >
                            Seçilen Otel:
                            <strong>
                              {{ arkmanMapping.coper.selected.Isim }}
                            </strong>
                          </div>

                          <v-slide-y-transition>
                            <div
                              v-if="showCoperList && coperPaged.length"
                              class="list-wrapper"
                            >
                              <v-list dense>
                                <v-list-tile
                                  v-for="h in coperPaged"
                                  :key="h.Ref"
                                  @click="selectCoperHotel(h)"
                                  :class="[
                                    'hotel-item',
                                    {
                                      'hotel-item--selected':
                                        arkmanMapping.coper.selected &&
                                        arkmanMapping.coper.selected.Ref === h.Ref
                                    }
                                  ]"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ h.Isim }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>

                              <v-layout
                                row
                                justify-space-between
                                align-center
                                class="pagination-row"
                              >
                                <v-btn
                                  small
                                  flat
                                  @click="prevCoperPage"
                                  :disabled="coperPage === 1"
                                >
                                  <v-icon left small>chevron_left</v-icon>
                                  Geri
                                </v-btn>

                                <span class="page-info">
                                  {{ coperPage }} / {{ coperMaxPage }}
                                </span>

                                <v-btn
                                  small
                                  flat
                                  @click="nextCoperPage"
                                  :disabled="coperPage >= coperMaxPage"
                                >
                                  İleri
                                  <v-icon right small>chevron_right</v-icon>
                                </v-btn>
                              </v-layout>

                            </div>
                          </v-slide-y-transition>

                        </v-card>
                      </v-flex>

                    </v-layout>

                    <!-- EŞLEŞTİR BUTONU -->
                    <v-layout row justify-center class="mt-4">
                      <v-btn
                        color="success"
                        large
                        :loading="arkmanMapping.saving"
                        :disabled="!arkmanMapping.ratehawk.selected || !arkmanMapping.coper.selected"
                        @click="mapSelectedHotels"
                      >
                        <v-icon left>link</v-icon>
                        Eşleştir
                      </v-btn>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>

          </v-layout>
        </v-tab-item>

        <!-- ================================================= -->
        <!-- ============ TAB 1 : EŞLEŞTİRİLENLER ============= -->
        <!-- ================================================= -->
        <v-tab-item>
          <v-layout row wrap>

            <v-flex xs12>
              <v-toolbar flat color="info" dark>
                <v-toolbar-title>
                  Eşleştirilen Oteller
                </v-toolbar-title>
                <v-spacer />
                <v-btn icon @click="loadMappedHotels">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-toolbar>
            </v-flex>

            <v-flex xs12>
              <v-data-table
                :headers="mappedHeaders"
                :items="mappedHotels"
                :loading="mappedLoading"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.RatehawkOtelAd }}</td>
                  <td>{{ props.item.CoperOtelAd }}</td>
                  <td class="text-xs-center">
                    <v-btn
                      icon
                      small
                      color="red"
                      @click="askDeleteMapping(props.item)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </td>
                </template>

                <template slot="no-data">
                  <div class="text-xs-center pa-3">
                    Henüz eşleştirilmiş otel bulunamadı.
                  </div>
                </template>

              </v-data-table>
            </v-flex>

          </v-layout>
        </v-tab-item>

      </v-tabs-items>
    </v-card>
<!-- UPDATE CONFIRM DIALOG -->
<v-dialog v-model="confirmDialog.visible" max-width="500">
  <v-card>
    <v-card-title class="headline">
      Eşleştirme Zaten Mevcut
    </v-card-title>

    <v-card-text style="white-space: pre-line;">
      {{ confirmDialog.message }}
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn flat @click="confirmDialog.visible = false">
        İptal
      </v-btn>

      <v-btn color="orange" flat @click="confirmDialogConfirm">
        Güncelle
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <!-- DELETE DIALOG -->
    <v-dialog v-model="deleteDialog.visible" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Eşleştirme Sil
        </v-card-title>
        <v-card-text>
          Bu eşleştirmeyi silmek istediğinize emin misiniz?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="deleteDialog.visible = false">
            İptal
          </v-btn>
          <v-btn color="red" flat @click="deleteMapping">
            Sil
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>


<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from "../../../../api/auth";

export default {
  data() {
    return {
      activeTab: 0,

      loadingvmodel: false,
      snackbar: false,
      text1: null,

      credentials: null,

      // UI state
      showRatehawkList: true,
      showCoperList: true,

      // mapping tarafı
      arkmanMapping: {
        ratehawk: {
          searchText: "",
          loading: false,
          results: [],
          selected: null,
          page: 1,
          pageSize: 10,
          backendPage: 1,   // API page
  backendPageSize: 100,
  hasMoreBackendData: true
        },
        coper: {
          searchText: "",
          loading: false,
          results: [],
          selected: null,
          page: 1,
          pageSize: 10
        },
        saving: false
      },

      // eşleştirilmiş oteller tablosu
      mappedHotels: [],
      mappedLoading: false,
      mappedHeaders: [
        { text: "Arkman Mapping Otel", value: "RatehawkOtelAd" },
        { text: "Coper Otel", value: "CoperOtelAd" },
        { text: "Sil", value: "actions", sortable: false, align: "center" }

      ],

      // popup onay diyaloğu
      confirmDialog: {
        visible: false,
        message: "",
        payload: null
      },
      deleteDialog: {
  visible: false,
  item: null
}
    };
  },

  components: {
    snackbarcomp,
    loadingcomp
  },

  mounted() {
    this.credentials = JSON.parse(window.localStorage.getItem("credentials"));
  },

  watch: {
    activeTab(val) {
      // Eşleştirilen oteller tabına geçince otomatik yükle
      if (val === 1) {
        this.loadMappedHotels();
      }
    }
  },

  computed: {
    // Arkman (Ratehawk) paging
    ratehawkPage() {
      return this.arkmanMapping.ratehawk.page;
    },
    ratehawkMaxPage() {
      const len = this.arkmanMapping.ratehawk.results.length || 0;
      return len === 0 ? 1 : Math.ceil(len / this.arkmanMapping.ratehawk.pageSize);
    },
    ratehawkPaged() {
      const { page, pageSize, results } = this.arkmanMapping.ratehawk;
      const start = (page - 1) * pageSize;
      return results.slice(start, start + pageSize);
    },

    // Coper paging
    coperPage() {
      return this.arkmanMapping.coper.page;
    },
    coperMaxPage() {
      const len = this.arkmanMapping.coper.results.length || 0;
      return len === 0 ? 1 : Math.ceil(len / this.arkmanMapping.coper.pageSize);
    },
    coperPaged() {
      const { page, pageSize, results } = this.arkmanMapping.coper;
      const start = (page - 1) * pageSize;
      return results.slice(start, start + pageSize);
    }
  },

  methods: {
    searchRatehawk,
    searchCoperHotels,
    selectRatehawkHotel,
    loadMoreRatehawkFromBackend,
    selectCoperHotel,
    nextRatehawkPage,
    nextCoperPage,
    prevRatehawkPage,
    mapSelectedHotels,
    updateMapSelectedHotels,
    loadMappedHotels,
askDeleteMapping(item) {
  this.deleteDialog.item = item;
  this.deleteDialog.visible = true;
},

deleteMapping() {
  const item = this.deleteDialog.item;
  if (!item) return;

  const c = this.credentials;
  this.loadingvmodel = true;

  this.$http.delete(
    auth.API_URL + "api/RateHawkHotels/DeleteMapping/" + item.Id,
    {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    }
  ).then(
    () => {
      this.loadingvmodel = false;
      this.deleteDialog.visible = false;
      this.text1 = "Eşleştirme silindi.";
      this.snackbar = true;
      this.loadMappedHotels();
    },
    () => {
      this.loadingvmodel = false;
      this.deleteDialog.visible = false;
      this.text1 = "Service Unavailable - DeleteMapping";
      this.snackbar = true;
    }
  );
},
    confirmDialogConfirm() {
      const p = this.confirmDialog.payload;
      this.confirmDialog.visible = false;
      if (p) {
        this.updateMapSelectedHotels(p);
      }
    }
  }
};

// =====================
//   FONKSİYONLAR
// =====================

function searchRatehawk() {
  if (
    
    !this.arkmanMapping.ratehawk.searchText ||
    this.arkmanMapping.ratehawk.searchText.length < 3
    
  ) {
    this.text1 = "En az 3 karakter giriniz (Arkman Mapping).";
    this.snackbar = true;
    return;
  }

  this.arkmanMapping.ratehawk.loading = true;
  this.showRatehawkList = true;
  this.arkmanMapping.ratehawk.results = [];
  this.arkmanMapping.ratehawk.page = 1;
  this.arkmanMapping.ratehawk.backendPage = 1;
  this.arkmanMapping.ratehawk.hasMoreBackendData = true;

  const params = {
    query: this.arkmanMapping.ratehawk.searchText,
    page: this.arkmanMapping.ratehawk.backendPage,
pageSize: this.arkmanMapping.ratehawk.backendPageSize
  };

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/Search", {
      params: params,
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader()
      }
    })
    .then(
  response => {
    const list = response.body || [];

    if (list.length < this.arkmanMapping.ratehawk.backendPageSize) {
      this.arkmanMapping.ratehawk.hasMoreBackendData = false;
    }

    this.arkmanMapping.ratehawk.results.push(...list);
    this.arkmanMapping.ratehawk.loading = false;
  },
  () => {
    this.arkmanMapping.ratehawk.loading = false;
    this.text1 = "Service Unavailable - Arkman Mapping Search";
    this.snackbar = true;
  }
);
}

function searchCoperHotels() {
  if (
    !this.arkmanMapping.coper.searchText ||
    this.arkmanMapping.coper.searchText.length < 2
  ) {
    this.text1 = "En az 2 karakter giriniz (Coper Otel).";
    this.snackbar = true;
    return;
  }

  this.arkmanMapping.coper.loading = true;
  this.showCoperList = true;

  const params = {
    searchTerm: this.arkmanMapping.coper.searchText
  };

  const c = this.credentials;

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/CoperHotels", {
      params: params,
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.coper.results = response.body || [];
        this.arkmanMapping.coper.page = 1;
        this.arkmanMapping.coper.loading = false;
      },
      () => {
        this.arkmanMapping.coper.loading = false;
        this.text1 = "Service Unavailable - CoperHotels";
        this.snackbar = true;
      }
    );
}

function selectRatehawkHotel(h) {
  this.arkmanMapping.ratehawk.selected = h;
  this.arkmanMapping.ratehawk.searchText = h.Name;
  this.showRatehawkList = false;
}

function selectCoperHotel(h) {
  this.arkmanMapping.coper.selected = h;
  this.arkmanMapping.coper.searchText = h.Isim;
  this.showCoperList = false;
}

function nextRatehawkPage() {
  const rh = this.arkmanMapping.ratehawk;

  // frontend sayfalar varsa
  if (rh.page < this.ratehawkMaxPage) {
    rh.page += 1;
    return;
  }

  // frontend bitti → backend’den yeni 100
  if (!rh.hasMoreBackendData || rh.loading) return;

  rh.backendPage += 1;

  loadMoreRatehawkFromBackend.call(this);

  // yeni veri gelince 11. sayfaya geç
  rh.page += 1;
}


function nextCoperPage() {
  if (this.coperPage < this.coperMaxPage) {
    this.arkmanMapping.coper.page += 1;
  }
}
function loadMoreRatehawkFromBackend() {
  const rh = this.arkmanMapping.ratehawk;
  if (rh.loading || !rh.hasMoreBackendData) return;

  rh.loading = true;

  const params = {
    query: rh.searchText,
    page: rh.backendPage,
    pageSize: rh.backendPageSize
  };

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/Search", {
      params,
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader()
      }
    })
    .then(
      response => {
        const list = response.body || [];

        if (list.length < rh.backendPageSize) {
          rh.hasMoreBackendData = false;
        }

        rh.results.push(...list); // 🔥 EKLE
        rh.loading = false;
      },
      () => {
        rh.loading = false;
        this.text1 = "Service Unavailable - Arkman Mapping Search";
        this.snackbar = true;
      }
    );
}
function prevRatehawkPage() {
  const rh = this.arkmanMapping.ratehawk;
  if (rh.page > 1) {
    rh.page -= 1;
  }
}

function mapSelectedHotels() {
  const rh = this.arkmanMapping.ratehawk.selected;
  const cp = this.arkmanMapping.coper.selected;

  if (!rh || !cp) {
    this.text1 = "Lütfen her iki taraftan da otel seçiniz.";
    this.snackbar = true;
    return;
  }

  const payload = {
    OtelRef: cp.Ref,
    OtelKod: cp.Kod,
    RatehawkKod: rh.Id,
    CoperOtelAd: cp.Isim,
    RatehawkOtelAd: rh.Name
  };

  const c = this.credentials;

  this.arkmanMapping.saving = true;
  this.loadingvmodel = true;

  this.$http
    .post(auth.API_URL + "api/RateHawkHotels/MapOtel", payload, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;

        const res = response.body || {};

        if (res.success === true && !res.conflictType) {
          this.text1 = res.message || "Eşleştirme kaydedildi.";
          this.snackbar = true;
          return;
        }

        if (res.success === true && res.isUpdated === false) {
          this.text1 = res.message || "Bu eşleştirme zaten mevcut.";
          this.snackbar = true;
          return;
        }

        // ÇAKIŞMA VARSA DİYALOG AÇ
        if (res.success === false && res.conflictType && res.existing) {
          const ex = res.existing;

          if (res.conflictType === "CoperAlreadyMapped") {
            const mevcutArkmanAd =
              ex.RatehawkOtelAd ||
              (this.arkmanMapping.ratehawk.selected &&
                this.arkmanMapping.ratehawk.selected.Name) ||
              ex.RatehawkKod;

            const msg =
              "Seçtiğiniz COPER otel daha önce başka bir Arkman Mapping oteli ile eşleştirilmiş.\n" +
              `Mevcut eşleşen Arkman Mapping Otel: ${mevcutArkmanAd}\n` +
              "Yeni eşleştirme ile güncellemek istiyor musunuz?";

            this.confirmDialog.message = msg;
            this.confirmDialog.payload = payload;
            this.confirmDialog.visible = true;
          } else if (res.conflictType === "RatehawkAlreadyMapped") {
            const mevcutCoperAd =
              ex.CoperOtelAd ||
              (this.arkmanMapping.coper.selected &&
                this.arkmanMapping.coper.selected.Isim) ||
              ex.OtelKod;

            const msg =
              "Seçtiğiniz Arkman Mapping otel daha önce başka bir COPER otel ile eşleştirilmiş.\n" +
              `Mevcut eşleşen COPER Otel: ${mevcutCoperAd}\n` +
              "Yeni eşleştirme ile güncellemek istiyor musunuz?";

            this.confirmDialog.message = msg;
            this.confirmDialog.payload = payload;
            this.confirmDialog.visible = true;
          }

          return;
        }

        this.text1 = "Bilinmeyen bir cevap alındı (MapOtel).";
        this.snackbar = true;
      },
      () => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;
        this.text1 = "Service Unavailable - MapOtel";
        this.snackbar = true;
      }
    );
}

function updateMapSelectedHotels(payload) {
  const c = this.credentials;

  this.arkmanMapping.saving = true;
  this.loadingvmodel = true;

  this.$http
    .post(auth.API_URL + "api/RateHawkHotels/UpdateMapOtel", payload, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;

        const res = response.body || {};
        if (res.success) {
          this.text1 = res.message || "Eşleştirme güncellendi.";
          this.snackbar = true;
          // Güncel listeyi de tazele
          if (this.activeTab === 1) {
            this.loadMappedHotels();
          }
        } else {
          this.text1 = "Eşleştirme güncellenemedi.";
          this.snackbar = true;
        }
      },
      () => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;
        this.text1 = "Service Unavailable - UpdateMapOtel";
        this.snackbar = true;
      }
    );
}

function loadMappedHotels() {
  if (!this.credentials) return;

  this.mappedLoading = true;
  const c = this.credentials;

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/Mappings", {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.mappedHotels = response.body || [];
        this.mappedLoading = false;
      },
      () => {
        this.mappedLoading = false;
        this.text1 = "Service Unavailable - Mappings";
        this.snackbar = true;
      }
    );
}
</script>

<style scoped>
.mapping-wrapper {
  padding: 16px;
  background: #f5f7fb;
}

.mapping-card {
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.08);
}

.mapping-toolbar {
  border-radius: 0;
}

.mapping-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.inner-card {
  border-radius: 12px;
}

.column-card {
  padding: 8px 16px;
}

.column-header {
  font-weight: 600;
  opacity: 0.8;
}

.search-row {
  margin-bottom: 8px;
}

.search-input >>> .v-input__slot {
  border-radius: 8px;
}

.search-button-wrap {
  display: flex;
  align-items: center;
}

.search-button {
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(33, 150, 243, 0.4);
}

.list-wrapper {
  max-height: 280px;
  overflow-y: auto;
  margin-top: 4px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
}

.hotel-item {
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.08s ease;
}

.hotel-item:hover {
  background-color: #f3f4ff;
}

.hotel-item--selected {
  background-color: #e0f2fe;
  font-weight: 600;
}

.pagination-row {
  padding: 4px 12px 8px 12px;
  border-top: 1px solid #e5e7eb;
}

.page-info {
  font-size: 12px;
  color: #6b7280;
}

.next-button {
  text-transform: none;
  font-size: 12px;
}

.match-button {
  min-width: 200px;
  border-radius: 24px;
  text-transform: none;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.45);
}

.selected-summary {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.selected-summary-name {
  font-weight: 600;
  color: #111827;
}
</style>
